import React from "react";
import FeedStory from "../feedStory/feedStory";
import { useRssFetch } from "../../custom-hooks/useRssFetch";
import LoadSpinner from "../loadSpinner/LoadSpinner";
import type { FeedItem, Story } from "../../types/rss";

export interface EspnFeedProps {
/** Path segment identifying which feed to load; omitted for top headlines. */
  urlStub?: string;
}

const EspnFeed = (props: EspnFeedProps) => {
  const feed = useRssFetch(
    `http://www.espn.com/espn/rss/${
      props.urlStub ? props.urlStub.concat("/") : ""
    }news`
  );

  if (!feed || !feed.items) {
    return <LoadSpinner />;
  }
  const stories: Story[] = [];
  feed.items.forEach(function (entry: FeedItem) {
    stories.push({
      name: entry.title ?? "",
      url: entry.link ?? "",
      img: entry.image ?? ""
    });
  });

  return (
    <div className="rssFeed">
      {stories.map((story, i) => {
        return <FeedStory key={i} story={story} shouldShowImage={i === 0} />;
      })}
    </div>
  );
};

export default React.memo(EspnFeed);
